import { useTranslation } from "react-i18next";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import LanguageSelector from "@/components/salnes/LanguageSelector";
import { Button } from "@/components/ui/button";

export default function PublicHeader() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const links = [
    { to: "/", label: t("nav.home") },
    { to: "/impacto", label: t("nav.impacto") },
    { to: "/transparencia", label: t("nav.transparency") },
    { to: "/datos-abertos", label: t("nav.opendata") },
  ];

  return (
    <header className="fixed top-0 inset-x-0 z-50">
      <div className="glass border-b hairline">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
            <img
              src="/brand/client/mancomunidade.png"
              alt="Mancomunidade do Salnés"
              className="h-9 w-auto"
              data-testid="header-logo-mancomunidade"
            />
            <div className="hidden sm:block leading-tight border-l border-salnes-stone/20 pl-3">
              <div className="font-serif text-[15px] text-salnes-ink" data-testid="public-header-brand-name">{t("brand.name")}</div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-salnes-stone">
                {t("brand.sub_id")}
              </div>
            </div>
            <div
              className="hidden lg:flex items-center gap-2 border-l border-salnes-stone/20 pl-3 ml-1"
              title="Operador de recogida — Valoriza Servicios Medioambientales"
              aria-label="Operador de recogida — Valoriza Servicios Medioambientales"
            >
              <img
                src="/brand/client/valoriza.svg"
                alt="Valoriza · Operador de recogida"
                className="h-6 w-auto opacity-90"
                data-testid="header-logo-valoriza"
              />
              <span className="text-[9px] uppercase tracking-[0.22em] text-salnes-stone/70">
                {t("header.operator_label", "Operador")}
              </span>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.to.replace(/\//g, "-") || "home"}`}
                className={({ isActive }) =>
                  `text-[13px] tracking-wide transition-colors ${
                    isActive
                      ? "text-salnes-atlantic"
                      : "text-salnes-ink/70 hover:text-salnes-atlantic"
                  }`
                }
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <LanguageSelector />
            <Link to="/login" data-testid="login-link">
              <Button
                variant="outline"
                size="sm"
                className="hidden sm:inline-flex rounded-full border-salnes-atlantic/30 text-salnes-atlantic hover:bg-salnes-atlantic hover:text-white transition-colors"
              >
                {t("nav.login")}
              </Button>
            </Link>
            <button
              type="button"
              className="md:hidden p-2 text-salnes-ink"
              onClick={() => setOpen((v) => !v)}
              data-testid="mobile-menu-toggle"
              aria-label="Menu"
            >
              {open ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>
        {open && (
          <div className="md:hidden border-t hairline bg-salnes-ivory/95">
            <div className="px-6 py-4 flex flex-col gap-3">
              {links.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  onClick={() => setOpen(false)}
                  className="text-sm text-salnes-ink/80"
                  data-testid={`mobile-nav-${l.to.replace(/\//g, "-") || "home"}`}
                >
                  {l.label}
                </Link>
              ))}
              <Link
                to="/login"
                onClick={() => setOpen(false)}
                className="text-sm text-salnes-atlantic font-medium"
              >
                {t("nav.login")}
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
